export const sortBy = <T>(
    array: T[],
    property: keyof T,
    order: "asc" | "desc" = "asc",
): T[] =>
    array.sort(
        (a, b) =>
            (order === "asc" ? 1 : -1) *
            String(a[property]).localeCompare(String(b[property])),
    );
